/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Dashboard from '@/views/Dashboard'
import Accounts from '@/views/Accounts'
import Helps from '@/views/Helps'
import Downloads from '@/views/Downloads'
import Categories from '@/views/Categories'

import Products from '@/views/Products'
import AddEditProduct from '@/views/Products/AddEdit'
import Images from '@/views/Products/Images'
import AddEditImage from '@/views/Products/Images/AddEdit'
import Photos from '@/views/Photos'
import AddEditPhoto from '@/views/Photos/AddEdit'
import PhotoImages from '@/views/Photos/PhotoImages'
import AddEditPhotoImage from '@/views/Photos/PhotoImages/AddEdit'
import Brandings from '@/views/Brandings'
import AddEditBranding from '@/views/Brandings/AddEdit'
import Presentations from '@/views/Presentations'
import AddEditPresentation from '@/views/Presentations/AddEdit'
import Advertisements from '@/views/Advertisements'
import AddEditAdvertisement from '@/views/Advertisements/AddEdit'
import SellSheetCategories from '@/views/SellSheetCategories'
import SellSheets from '@/views/SellSheets'
import AddEditSellSheet from '@/views/SellSheets/AddEdit'
import PublicRelations from '@/views/PublicRelations'
import AddEditPublicRelation from '@/views/PublicRelations/AddEdit'
import Videos from '@/views/Videos'
import AddEditVideo from '@/views/Videos/AddEdit'
import C1868Categories from '@/views/C1868Categories'
import C1868s from '@/views/C1868s'
import AddEditC1868 from '@/views/C1868s/AddEdit'

import store from '@/store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login',
        requiresAuth: false
      }
    },
    {
      path: '/accounts',
      name: 'Accounts',
      component: Accounts,
      meta: {
        title: 'Accounts',
        requiresAuth: true
      }
    },
    {
      path: '/helps',
      name: 'Helps',
      component: Helps,
      meta: {
        title: 'Helps',
        requiresAuth: true
      }
    },
    {
      path: '/downloads',
      name: 'Downloads',
      component: Downloads,
      meta: {
        title: 'Downloads',
        requiresAuth: true
      }
    },
    {
      path: '/categories',
      name: 'Categories',
      component: Categories,
      meta: {
        title: 'Categories',
        requiresAuth: true
      }
    },
    {
      path: '/products',
      name: 'Products',
      component: Products,
      meta: {
        title: 'Products',
        requiresAuth: true
      }
    },
    {
      path: '/product/add',
      name: 'AddProduct',
      component: AddEditProduct,
      meta: {
        title: 'Add Product',
        requiresAuth: true
      }
    },
    {
      path: '/product/edit/:id',
      name: 'EditProduct',
      component: AddEditProduct,
      meta: {
        title: 'Edit Product',
        requiresAuth: true
      }
    },
    {
      path: '/products/:id/images',
      name: 'Images',
      component: Images,
      meta: {
        title: 'Images',
        requiresAuth: true
      }
    },
    {
      path: '/products/:parent_id/image/add',
      name: 'AddImage',
      component: AddEditImage,
      meta: {
        title: 'Add Image',
        requiresAuth: true
      }
    },
    {
      path: '/products/:parent_id/image/edit/:id',
      name: 'EditImage',
      component: AddEditImage,
      meta: {
        title: 'Edit Image',
        requiresAuth: true
      }
    },
    {
      path: '/photos',
      name: 'Photos',
      component: Photos,
      meta: {
        title: 'Photos',
        requiresAuth: true
      }
    },
    {
      path: '/photo/add',
      name: 'AddPhoto',
      component: AddEditPhoto,
      meta: {
        title: 'Add Photo',
        requiresAuth: true
      }
    },
    {
      path: '/photo/edit/:id',
      name: 'EditPhoto',
      component: AddEditPhoto,
      meta: {
        title: 'Edit Photo',
        requiresAuth: true
      }
    },
    {
      path: '/photos/:id/photo-images',
      name: 'PhotoImages',
      component: PhotoImages,
      meta: {
        title: 'Photo Images',
        requiresAuth: true
      }
    },
    {
      path: '/photos/:parent_id/photo-image/add',
      name: 'AddPhotoImage',
      component: AddEditPhotoImage,
      meta: {
        title: 'Add Photo Image',
        requiresAuth: true
      }
    },
    {
      path: '/photos/:parent_id/photo-image/edit/:id',
      name: 'EditPhotoImage',
      component: AddEditPhotoImage,
      meta: {
        title: 'Edit Photo Image',
        requiresAuth: true
      }
    },
    {
      path: '/branding-and-logo',
      name: 'BrandingAndLogo',
      component: Brandings,
      meta: {
        title: 'Presentation And Material',
        requiresAuth: true
      }
    },
    {
      path: '/branding/add',
      name: 'AddBranding',
      component: AddEditBranding,
      meta: {
        title: 'Add Branding',
        requiresAuth: true
      }
    },
    {
      path: '/branding/edit/:id',
      name: 'EditBranding',
      component: AddEditBranding,
      meta: {
        title: 'Edit Branding',
        requiresAuth: true
      }
    },
    {
      path: '/presentation-materials',
      name: 'PresentationAndMaterial',
      component: Presentations,
      meta: {
        title: 'Presentation And Material',
        requiresAuth: true
      }
    },
    {
      path: '/presentation/add',
      name: 'AddPresentation',
      component: AddEditPresentation,
      meta: {
        title: 'Add Presentation',
        requiresAuth: true
      }
    },
    {
      path: '/presentation/edit/:id',
      name: 'EditPresentation',
      component: AddEditPresentation,
      meta: {
        title: 'Edit Presentation',
        requiresAuth: true
      }
    },
    {
      path: '/advertisements',
      name: 'Advertisements',
      component: Advertisements,
      meta: {
        title: 'Advertisements',
        requiresAuth: true
      }
    },
    {
      path: '/advertisement/add',
      name: 'AddAdvertisement',
      component: AddEditAdvertisement,
      meta: {
        title: 'Add Advertisement',
        requiresAuth: true
      }
    },
    {
      path: '/advertisement/edit/:id',
      name: 'EditAdvertisement',
      component: AddEditAdvertisement,
      meta: {
        title: 'Edit Advertisement',
        requiresAuth: true
      }
    },
    {
      path: '/sell-sheet-categories',
      name: 'SellSheetCategories',
      component: SellSheetCategories,
      meta: {
        title: 'Sell Sheet Categories',
        requiresAuth: true
      }
    },
    {
      path: '/sell-sheets',
      name: 'SellSheets',
      component: SellSheets,
      meta: {
        title: 'Sell Sheets',
        requiresAuth: true
      }
    },
    {
      path: '/sell-sheet/add',
      name: 'AddSellSheet',
      component: AddEditSellSheet,
      meta: {
        title: 'Add Sell Sheet',
        requiresAuth: true
      }
    },
    {
      path: '/sell-sheet/edit/:id',
      name: 'EditSellSheet',
      component: AddEditSellSheet,
      meta: {
        title: 'Edit Sell Sheet',
        requiresAuth: true
      }
    },
    {
      path: '/public-relations',
      name: 'PublicRelations',
      component: PublicRelations,
      meta: {
        title: 'Public Relations',
        requiresAuth: true
      }
    },
    {
      path: '/public-relation/add',
      name: 'AddPublicRelation',
      component: AddEditPublicRelation,
      meta: {
        title: 'Add Public Relation',
        requiresAuth: true
      }
    },
    {
      path: '/public-relation/edit/:id',
      name: 'EditPublicRelation',
      component: AddEditPublicRelation,
      meta: {
        title: 'Edit Public Relation',
        requiresAuth: true
      }
    },
    {
      path: '/videos',
      name: 'Videos',
      component: Videos,
      meta: {
        title: 'Videos',
        requiresAuth: true
      }
    },
    {
      path: '/video/add',
      name: 'AddVideo',
      component: AddEditVideo,
      meta: {
        title: 'Add Video',
        requiresAuth: true
      }
    },
    {
      path: '/video/edit/:id',
      name: 'EditVideo',
      component: AddEditVideo,
      meta: {
        title: 'Edit Video',
        requiresAuth: true
      }
    },
    {
      path: '/1868-categories',
      name: 'C1868Categories',
      component: C1868Categories,
      meta: {
        title: 'C1868 Categories',
        requiresAuth: true
      }
    },
    {
      path: '/1868s',
      name: 'C1868s',
      component: C1868s,
      meta: {
        title: 'C1868s',
        requiresAuth: true
      }
    },
    {
      path: '/1868/add',
      name: 'AddC1868',
      component: AddEditC1868,
      meta: {
        title: 'Add 1868',
        requiresAuth: true
      }
    },
    {
      path: '/1868/edit/:id',
      name: 'EditC1868',
      component: AddEditC1868,
      meta: {
        title: 'Edit 1868',
        requiresAuth: true
      }
    },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    Vue.$toast.error('Please login first!')
    next('/login')
  } else if (to.matched.some(record => record.meta.requiresAuth === false)) {
    if (store.getters.isLoggedIn) {
      next('/')
      return
    }
    next()
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js